import { render } from "./HomeView2.vue?vue&type=template&id=1d4c3618"
import script from "./HomeView2.vue?vue&type=script&lang=js"
export * from "./HomeView2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__